import PricingForm from './pricingForm'
export default PricingForm
